import { useAppSelector } from 'src/hook/useAppSelector';
import { selectRoles } from 'src/store/slice/authSlice';

/**
 * Permission model:
 *  admin - full access on all screens
 *  uat   - full access on /uat screens, view-only everywhere else
 */
export const usePermissions = () => {
    const roles = useAppSelector(selectRoles);

    const isAdmin = roles.includes('admin');
    const isUat = roles.includes('uat');

    return {
        isAdmin,
        canEditTools: isAdmin,
        canManageTestSuites: isAdmin,
        canAccessAgent: isAdmin,
        canAccessUat: isAdmin || isUat,
    };
};
